// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"9963dc03","591":"38293ba1"}[chunkId] + ".chunk.css";
};